export enum CommunicationType {
  NotSet = 'NotSet',
  Call = 'Call'
}
